import { render, staticRenderFns } from "./SummaryCarEar.vue?vue&type=template&id=72cc6c67&scoped=true&"
import script from "./SummaryCarEar.vue?vue&type=script&lang=js&"
export * from "./SummaryCarEar.vue?vue&type=script&lang=js&"
import style0 from "./SummaryCarEar.vue?vue&type=style&index=0&id=72cc6c67&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cc6c67",
  null
  
)

export default component.exports